// removed by extract-text-webpack-plugin
module.exports = {"headline":"src-components-modules-Hero-HeroMedia-style----headline-module---headline---3MDoJ centered position-relative zi-weak"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Hero/HeroMedia/style/headline.module.css
// module id = 1473
// module chunks = 168707334958949